<template>
  <div v-if="!showDetail">
    <div class="advanceParent">
      <app-history
        @clicked="showInsertDialog()"
        title="ثبت لیست پرداخت"
        class="advancedSearch"
      />
    </div>

    <div>
      <v-data-table
        :items="payments"
        :server-items-length="totalCount"
        :headers="paymentsHeaders"
        class="elevation-1 rounded"
        :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
          itemsPerPageOptions: [10],
        }"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
        @pagination="doPage"
      >
        <template v-slot:[`item.total`]="{ item }">
          {{ Number(item.total).toLocaleString() }}
        </template>
        <template v-slot:[`item.detail`]="{ item }">
          <font-awesome-icon
            icon="angle-left"
            class="navIcon"
            title="مشاهده جزییات"
            @click="handleShowDetail(item)"
          />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            class="dialogButton paybackButton"
            rounded
            @click="exportExcel(item.id)"
          >
            خروجی اکسل</v-btn
          >
        </template>
        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
          از {{ pageStart }} تا {{ pageStop }}
        </template>
      </v-data-table>
      <app-dialog @close="RequestNewList"></app-dialog>
    </div>
  </div>
  <div v-else>
    <app-detail :item="selectedItem" />
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import Detail from "./Detail";
import { toArabicCharacter } from "@/utils/constants";
import { saveByteArray } from "@/utils/constants";

import {
  GetAdminPardakhtList,
  InsertPardakhtList,
  ExportReportAsExcel,
} from "@/api/payments";
import { FindUserByCode } from "@/api/user";
import moment from "moment-jalaali";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
    appDetail: Detail,
  },
  data() {
    return {
      showPaymentDialog: false,
      payments: [],

      paymentsHeaders: [
        {
          text: "شماره لیست",
          value: "id",
          width: "10%",
        },

        {
          text: "تاریخ شروع",
          value: "startDate",
          width: "15%",
          cellClass: "cellLtr",
        },
        {
          text: "تاریخ پایان",
          value: "endDate",
          width: "15%",
          cellClass: "cellLtr",
        },
        {
          text: "تعداد مدارس",
          value: "cnt",
          width: "10%",
          sortable: false,
        },
        {
          text: "جمع کل (ریال)",
          value: "total",
          width: "20%",
          sortable: false,
        },
        {
          text: "تاریخ پرداخت",
          value: "state",
          width: "25%",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          sortable: false,
        },
        {
          text: "",
          value: "detail",
          width: "5%",
          sortable: false,
        },
      ],

      showDetail: false,
      totalCount: 0,
      selectedItem: {},
    };
  },
  created() {
    this.GetAdminPardakhtList();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },

  methods: {
    convertDate(date) {
      return moment(date).format("jYYYY/jMM/jDD HH:mm");
    },
    GetAdminPardakhtList(skip) {
      if (isNaN(skip)) skip = 0;
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetAdminPardakhtList(skip)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.payments = response.data.items;
            this.totalCount = response.data.count;
            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    handleShowDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    },
    async GetDataForExcel() {
      const response = await GetAdminPardakhtList(-1);
      return response.data.items;
    },

    doPage($event) {
      this.GetAdminPardakhtList(($event.page - 1) * 10);
    },
    showInsertDialog() {
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", 1);
      var startDate = "1401/01/01";
      var endDate = moment()
        .add("days", -1)
        .format("jYYYY/jMM/jDD");
      if (this.payments.length > 0) {
        startDate = moment(this.payments[0].endDate, "jYYYY/jMM/jDD")
          .add("days", 1)
          .format("jYYYY/jMM/jDD");
      }
      if (startDate > endDate) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "لیست پرداخت پیشتر تا این تاریخ ایجاد شده است."
        );
        return;
      }
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        "آیا مایل به ایجاد لیست پرداخت از تاریخ " +
          startDate +
          " تا تاریخ " +
          endDate +
          " هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
    RequestNewList(index) {
      if (index != -1) {
        //this.$store.commit("SET_API_RUNNING", true);
        InsertPardakhtList()
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showPaymentDialog = false;
            this.GetAdminPardakhtList();
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    exportExcel(id) {
      ExportReportAsExcel(id)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);

          saveByteArray(data, "گزارش تراکنش های لیست " + id + ".xlsx");
        })
        .catch((error) => {
          console.log(error)
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    const IsItABackButton = window.popStateDetected;
    window.popStateDetected = false;
    /**
     * user clicked on  menu
     */
    if (!IsItABackButton) {
      this.selectedItem = {};
      this.showDetail = false;
      next();
    } else if (this.selectedItem.id == undefined) {
      next();
    } else {
      this.selectedItem = {};
      this.showDetail = false;
      next(false);
    }
  },
};
</script>
<style>
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}

.filterButton {
  width: 100%;
}
.navIcon {
  font-size: 150%;
  cursor: pointer;
}
</style>
